import { useState } from "react";
import { Bell } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import NotificationCenterList from "@/components/notifications/NotificationCenterList";
import { useNotificationCenter } from "@/hooks/useNotificationCenter";

/** Always visible: also the entry point when there are zero unread items. */
export default function NotificationBell() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { unreadCount } = useNotificationCenter();
  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant="ghost" size="sm"
          aria-label={t("notificationCenter.title")}
          title={t("notificationCenter.title")}
          className="relative h-10 w-10 rounded-full p-0 border border-primary/30 bg-secondary/40 hover:bg-primary/10"
          data-testid="notification-bell">
          <Bell className="h-5 w-5" />
          {unreadCount > 0 && (
            <span className="absolute -right-1 -top-1 min-w-4 h-4 rounded-full bg-primary px-1 text-[10px] font-bold leading-4 text-primary-foreground text-center"
              aria-label={t("notificationCenter.unreadCount", { count: unreadCount })}>
              {unreadCount > 9 ? "9+" : unreadCount}
            </span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[min(24rem,calc(100vw-1rem))] max-h-[76vh] overflow-y-auto p-3">
        <NotificationCenterList compact onNavigate={() => setOpen(false)} />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
